import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CombosStore } from '@app/requests/combos-service/combos.store';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { AdminStore } from '../admin-service/admin-service.store';
import { AttachDocumentDTO } from '../model/users-model';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { UpdateComponent } from '@app/@shared/update/update.component';

interface FileUpload {
  numFile: number;
  file: File | any;
  description: string;
}

@Component({
  selector: 'app-brand',
  templateUrl: './brand.component.html',
  styleUrls: ['./brand.component.scss'],
})
export class BrandComponent implements OnInit {
  @ViewChild(UpdateComponent)
  private updateComponent: UpdateComponent;

  selectedFile: FileUpload = null;

  public languageList: CommonDataDTO[] = [];
  public optionList: CommonDataDTO[] = [];

  public brandForm: FormGroup;

  public isAcceptEnabled: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private adminStore: AdminStore,
    private combosStore: CombosStore,
    private dialog: MatDialog,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.brandForm = this.formBuilder.group({
      brand: ['', Validators.required],
      language: ['', Validators.required],
      beneficiary: ['', Validators.required],
      numBeneficiary: ['', Validators.required],
      withShopping: ['', Validators.required],
      withoutShopping: ['', Validators.required],
      codWorker: ['', Validators.required],
      codReference: ['', Validators.required],
      insurance: ['', Validators.required],
      postalCode: ['', Validators.required],
      discount: ['', Validators.required],
      color: ['', Validators.required],
    });

    this.brandForm.statusChanges.subscribe(() => {
      this.changeStatusAccept();
    });

    this.languageList = this.combosStore.languages;
    this.optionList = this.combosStore.affirmativeNegativeList;
  }

  onClickAccept() {
    if (this.selectedFile) {
      this.getBase64(this.selectedFile.file).then((fileBase64: string) => {
        if (fileBase64) {
          let file: AttachDocumentDTO = {
            fileName: this.selectedFile.file.name?.split('.')[0],
            description: this.selectedFile.description,
            base64: fileBase64,
            extension: this.selectedFile.file.type?.split('/')[1],
          };

          const dialogConfig = new MatDialogConfig();
          dialogConfig.width = '90%';
          dialogConfig.maxWidth = '550px';

          this.adminStore
            .createBrandMaintenance(file, this.brandForm)
            .then(
              () => {
                dialogConfig.data = {
                  icon: 'icon-ic_circle_check',
                  text: this.translateService.instant('brandMaintenance.dialog.success').toUpperCase(),
                  noRedirect: true,
                };
                this.dialog.open(ResponseDialogComponent, dialogConfig);
              },
              (error) => {
                let errorMessage =
                  error.error?.message === 'Brand exist in BBDD'
                    ? this.translateService.instant('brandMaintenance.dialog.errorDuplicate').toUpperCase()
                    : this.translateService.instant('brandMaintenance.dialog.error').toUpperCase();

                dialogConfig.data = { text: errorMessage, icon: 'icon-ic_circle_cross', noRedirect: true };
                this.dialog.open(ResponseDialogComponent, dialogConfig);
              }
            )
            .finally(() => {
              this.brandForm.reset();
              this.updateComponent.reset();
            });
        }
      });
    }
  }

  onClickCancel() {
    this.brandForm.reset();
    this.updateComponent.reset();
    this.selectedFile = null;
  }

  saveFile(file: FileUpload) {
    if (file.description === '' && file.file === undefined) {
      this.selectedFile = null;
    } else {
      this.selectedFile = file;
    }
    this.changeStatusAccept();
  }

  private getBase64(file: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result?.toString().split(',')[1]);
      reader.onerror = (error) => reject(error);
    });
  }

  private changeStatusAccept() {
    const isSelectedFile = !!this.selectedFile;
    this.isAcceptEnabled = this.brandForm.status === 'VALID' && isSelectedFile;
  }
}
